module.exports = __webpack_public_path__ + "img/kg.665952c0.svg";